import getData from "common/fetch/get";
import getStaticData from "common/fetch/getStaticData";

import Layout from "components/common/Layout";
import SGForeigner from "components/templates/sg/sg-foreigner";

import dataJson from "./data.json";

export default function Home({ data }) {
  return (
    <Layout locationRouter="sg" navLight={true} page={data.page}>
      <SGForeigner data={data} dataJson={dataJson} />
    </Layout>
  );
}

export const getStaticProps = async () => {
  const includeId = [88, 89];
  const data = await getStaticData({
    locale: "sg",
    uri: "/company-incorporation-foreigners",
    data_package: {
      countryId: 191,
      websiteId: 2,
      subParam: "&package_group_id=1",
      filter: {
        includeId,
      },
      queryStr: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/services?country_id=191&website_id=2&package_group_id=1`,
    },
    postQuery: {
      postPerPage: 3,
      array_post_id: [4388, 8682, 8102],
    },
  });

  const dataRenewal = await getData({
    url: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/services?country_id=191&website_id=2&package_group_id=3`,
  });
  const customDataRenewal = dataRenewal.data.Packages.map((item, index) => ({
    ...item,
    mapping_package_id: includeId[index],
  }));

  return {
    props: {
      data: {
        ...data,
        dataPackage: {
          ...data.dataPackage,
          dataRenewal: customDataRenewal,
        },
      },
      revalidate: 1,
    },
  };
};
